module.exports = __webpack_public_path__ + "static/media/FOBTag.007f1397.png";